import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { PayBill } from '@models/paybill';

@Injectable({
  providedIn: 'root',
})
export class CompanyTypeService {
  constructor(private http: HttpClient) {}
  acicPolicyPrefixes: string[] = ["ACPA","ACH1","ACH3","ACH4","ACH6","ACD2","ACD3","ACBT","ACM3","CIPA","CIH1","CIH3","CIH4","CIH6","CID2","CID3","NH"];
  aaaFourCodes: string[] = ["7100","2100","7101","2101", "9101","7102","2102","9102","7110","2110","9110","7111","2111","9111","7112", "2112", "9112"];
  aaaThreeCodes: string[] = ["100", "101","102","110","111","112"];
  twCodes: string[] = ["80","64","52"];
  acicStates: string[] = ["WA","RI","CT","VT","ME","OH"]

  getCompanyName(policyNumber: string): Observable<any> {
    policyNumber = policyNumber.replace('-', '')?.toUpperCase();;
    const url = `${environment.backend_server_url_account}/guest/${policyNumber}/company`;
    return this.http.get(url);
  }

  isAcicCompany(policyNumber: string): boolean{
    const prefix = policyNumber.substring(0, 4);
    
    return (policyNumber.startsWith("NH") || this.acicPolicyPrefixes.includes(prefix))
  }

  isTWCompany(policyNumber: string): boolean{
    const code = policyNumber.substring(0, 2);
    
    return (policyNumber.length > 10 && this.twCodes.includes(code))
  }

  getCompany(policyNumber: string): string {
    if(policyNumber.length === 6) {
      return "AS400";
    }
    
    if(this.isAcicCompany(policyNumber)) {
      return "ACIC";
    }

    if(this.isTWCompany(policyNumber)) {
      return "TW";
    }

    if(this.aaaFourCodes.includes(policyNumber.substring(0, 4)) 
              || this.aaaThreeCodes.includes(policyNumber.substring(0, 3))) {
      return "AAA";
    }

    return "MAPFRE";
  }

  getPayBill(state, company, policyNumber){
    if (company.companyName=='ACIC' && this.acicStates.includes(state)){
      if (company.companyId=="03"){
        return PayBill.company03
      } else if (company.companyId=="05"){
        return PayBill.company05
      } else if (company.companyId=="25"){
        return PayBill.company25
      } else 
        return PayBill.as400
    } else if (company.companyName=='ACIC' && state=="NH") {
      if (policyNumber.toLowerCase().startsWith("nh")){
        return PayBill.nh01
    } else 
        return PayBill.nh03
  }
    else if (company.companyName=='ACIC' && !this.acicStates.includes(state)) {
       return PayBill.OR
    } else if (company.companyName=='TW') {
      if (company.companyId=="80"){
        return PayBill.CA
      } else if (company.companyId=="64" && policyNumber.substring(3, 6)=="104") {
        return PayBill.CA_64_104
      } else if (company.companyId=="64"){
        return PayBill.CA_64
      } else {
        return PayBill.CA
      }
    } else {
      return PayBill.as400
    }

  }

}
